
<template>
  <div 
    :class="'hidden md:block bg-gray-100 pr-3 border-b border-gray-300 pl-0 md:pl-' + this.$store.state.sizes.navigationWidth + 'px '"
    style="position:fixed;top:69px;left:0;width:100%;padding-top:15px;padding-bottom: 15px;">
    
    <div class="overflow-hidden pl-6 pr-1">
      <!-- <div class="float-left" style="margin-top:12px;">
        Search for clients
      </div> -->

      <!-- <div class="float-left relative" style="margin-right:30px;">
        <input type="text" 
          class="border border-gray-500 focus:border-gray-600 outline-none p-2 text-sm"
          style="width:250px;padding-left:35px;"
          :value="query"
          v-on:keyup.enter="queryTyped($event.target.value)"
          placeholder="Search for client" />

        <div style="position: absolute;top:8px;left:10px;" class="text-gray-700 text-sm">
          <svg width="16" height="16" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
            <use xlink:href="/static/img/feather-sprite.svg#search"/>
          </svg>
        </div>
      </div> -->

      <div class="float-left text-sm" style="margin:8px 8px 0 0;">
        Acitivity type
      </div>

      <div class="float-left">
        <select class="border border-gray-500 bg-white outline-none" 
          style="height:34px;width:200px;"
          v-model="activityType">
          <option value="all">Show all</option>
          <option value="page-edited">Form updated</option>
          <option value="application-sent-broker">Form sent by you</option>
          <option value="application-sent-client">Form received from clients</option>

        </select>
      </div>

      <!-- <div class="float-right">
        <a href="#" 
          @click.prevent="addNewClient()" 
          class="inline-block bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold uppercase no-underline"
          style="padding:14px 18px;">
          <span class="">+</span>
          <span class="">Add a new client</span>
        </a>
      </div> -->
    </div>

    
    <!-- <div class="text-lg font-thin text-gray-700 overflow-hidden px-4" style="margin-top:35px;">
      <div class="float-left" style="margin-top:2px;">
        <svg width="18" height="18" stroke-width="2" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#filter"/>
        </svg>  
      </div>

      <div class="float-left ml-2" style="">
        Filter table
      </div>
    </div>



    <div class="mt-8 text-gray-700 pb-1 px-4">
      Client type
    </div>

    <div class="overflow-hidden px-3">
      <div class="float-left m-1">
        <input type="radio" 
          name="input-client-type" 
          id="input-client-type-active"
          v-model="clientType"
          value="active" />  
      </div>

      <div class="float-left" style="margin:6px 0 0 5px;">
        <label for="input-client-type-active" class="text-gray-900">Active clients</label>
      </div>
    </div>

    <div class="overflow-hidden px-3">
      <div class="float-left m-1">
        <input type="radio" 
          name="input-client-type" 
          id="input-client-type-settled"
          v-model="clientType"
          value="settled" />  
      </div>

      <div class="float-left" style="margin:6px 0 0 5px;">
        <label for="input-client-type-settled" class="text-gray-900">Settled clients</label>
      </div>
    </div> -->




  </div>
</template>

<script>

  import { EventBus } from '@/shared/event-bus'

  export default {

    components : {

    },

    props : {
      params : {
        type    : Object,
        required: false
      }
    },

    data() {
      return {
        query       : null,
        activityType: this.params.activityType
      }
    },

    watch: {

      '$route' : {
        immediate: true,
        handler  : function(newVal, oldVal) {
          this.status = newVal.params.status
        }
      },
      // 'query' : (newVal, oldVal) => {
      //   EventBus.$emit('param-changed', {
      //     key  : 'query',
      //     value: newVal
      //   })
      // },

      'activityType' : (newVal, oldVal) => {
        EventBus.$emit('param-changed', {
          key  : 'activityType',
          value: newVal
        })
      },
    },

    methods : {

      queryTyped(value) {
        EventBus.$emit('param-changed', {
          key  : 'query',
          value: value
        })
      },
    }

  }
</script>

<style scoped>

</style>